import { WALLET_MANAGER } from '../global-constants.js';

// Insert the My Wallet Bonnet Shared Bundle
export const loadWalletManager = async (API, walletManagerHost) => {
	return API.loadJS(`${walletManagerHost}/${WALLET_MANAGER}.js`);
}
